import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useApiBaseUrl } from '../context/ApiContext';

const CONTRACT_CUSTOMER_IDS = ['CU-001034', 'CU-000972'];

const NewOrder = ({selectedCustomerId, onClose, handleSetNewOrderId}) => {
  const ApiBaseUrl = useApiBaseUrl();
  const [customerPONumber, setCustomerPONumber] = useState('');
  const [carrier, setCarrier] = useState('');
  const [shippingInfo, setShippingInfo] = useState('');
  const [requestedShipDate, setRequestedShipDate] = useState(new Date());
  const [poolLoad, setPoolLoad] = useState('');
  const [freightArrangedByDUSA, setFreightArrangedByDUSA] = useState('');
  const [ShipmentData, setShipmentData] = useState(null);
  const [selectedShippingAgentCode, setSelectedShippingAgentCode] = useState(null);
  const [selectedShipToCode, setSelectedShipToCode] = useState(null);
  const [selectedLocationCode, setSelectedLocationCode] = useState(null);
  //const [startingRequestedShipDate, setStartingRequestedShipDate] = useState();
  const [startingNewOrder, setStartingNewOrder] = useState(false);
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   // Handle form submission logic here
  //   console.log('Form submitted', { customerPONumber, shippingInfo, requestedShipDate, freightArrangedByDUSA });
  // };

  const [OrderCycleInfo, setOrderCycleInfo] = useState(null);

  // Helper to add N business days (Mon-Fri) to a given date
  const addBusinessDays = (startDate, businessDaysToAdd) => {
    const date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    let added = 0;
    while (added < businessDaysToAdd) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) {
        added++;
      }
    }
    return date;
  };

  useEffect(() => {
    const fetchOrderCycleInfo = async () => {
      try {
        const response = await fetch(`${ApiBaseUrl}/api/Sales/GetOrderCycleInfo`);
        const data = await response.json();
        setOrderCycleInfo(data);
        console.log('OrderCycleInfo retrieved from GetOrderCycleInfo:', data);
        // For contract customers (CU-001034, CU-000972), default to today; otherwise use minShipDate
        if (CONTRACT_CUSTOMER_IDS.includes(selectedCustomerId)) {
          const today = new Date();
          today.setHours(0,0,0,0);
          setRequestedShipDate(today);
        } else {
          setRequestedShipDate(new Date(data.minShipDate));
        }
      } catch (error) {
        console.error('Error fetching order cycle info:', error);
      }
    };

    fetchOrderCycleInfo();
  }, []);

   useEffect(() => {
    const fetchShipmentData = async () => {
      try {
        const response = await fetch(`${ApiBaseUrl}/api/Sales/${selectedCustomerId}/GetShipmentInfoCustomers_ByEmail`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setShipmentData(data);
        console.log('Shipment data retrieved from GetShipmentInfoCustomers_ByEmail:', data);
      } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
      }
    };

    fetchShipmentData();
  }, []);

  const handleCreateNewOrder = () => {
    // console.log('Creating new order', { customerPONumber, shippingInfo, requestedShipDate, selectedLocationCode,
    //   'freightArrangedByDUSA_original': freightArrangedByDUSA,
    //    freightArrangedByDUSA: freightArrangedByDUSA === '' ? '' : freightArrangedByDUSA === 'true',
    //    shippingAgentCode: freightArrangedByDUSA === '' ? '' : freightArrangedByDUSA === 'true' ? selectedShippingAgentCode : 'DIST',
    //    selectedShipToCode });
    // //selectedShipmentData
    // console.log('selectedShippingAgentCode:', freightArrangedByDUSA === "true" ? selectedShippingAgentCode : 'DIST' );
    // console.log('selectedShipToCode:', selectedShipToCode);
    setStartingNewOrder(true);

    const orderData = {
      Klant: selectedCustomerId,
      CustomerPO: customerPONumber,
      DuvelArrangesFreight: freightArrangedByDUSA === 'true',
      ShippingAgentCode: freightArrangedByDUSA === 'true' ? selectedShippingAgentCode : 'DIST',
      LocationCode: selectedLocationCode,
      ExpectedShipDate: requestedShipDate,
      OrderCycle: '',
      CreatedBy: '',
      ShipToCode: selectedShipToCode,
      Carrier: carrier,
      PoolLoad: poolLoad
    };
  
    console.log('Creating new order', orderData);
    createNewOrder(orderData);
  };

  const createNewOrder = async (orderData) => {
    try {
      const response = await fetch(`${ApiBaseUrl}/api/Sales/${selectedCustomerId}/CreateNewOrder`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(orderData),
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const data = await response.json();
      console.log('New order created:', data);
      handleSetNewOrderId(data);
      return data;
    } catch (error) {
      console.error('There was a problem with the create order operation:', error);
      throw error;
    }
  };


  const handleSelectedShippingInfo = (e) => {
    console.log('Selected shipping info:', e.target.value);
    var selectedShippingAgentCode = e.target.value.split('_')[1];
    setSelectedShippingAgentCode(selectedShippingAgentCode);
    var selectedShipToCode = e.target.value.split('_')[0];
    setSelectedShipToCode(selectedShipToCode);
    var selectedLocationCode = e.target.value.split('_')[2];
    setSelectedLocationCode(selectedLocationCode);
  };

  const handleFreightChange = (e) => {
    setFreightArrangedByDUSA(e.target.value);
  };
  

  return (
    <div className="new-order-form" style={{ backgroundColor: '#c41e3a', color: 'white', padding: '20px', maxWidth: '700px', width: '600px', margin: 'auto', position: 'absolute', zIndex: '9999', marginLeft: '30%', top: '256px', boxShadow: 'black 10px 10px 24px -8px' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px', color: 'white' }}>NEW ORDER</h2>
      <>
        <div className="form-group" style={{ marginBottom: '15px' }}>
          <label style={{ textAlign: 'left', display: 'block' }}>Customer PO Number: <span style={{ color: 'orange' }}>*</span></label>
          <input
            type="text"
            value={customerPONumber}
            onChange={(e) => setCustomerPONumber(e.target.value)}
            style={{ width: '98%', padding: '5px' }}
          />
        </div>


        {/* Carrier: this field only exists for contract customers */}
        {CONTRACT_CUSTOMER_IDS.includes(selectedCustomerId) && (
          <div className="form-group" style={{ marginBottom: '15px' }}>
            <label style={{ textAlign: 'left', display: 'block' }}>Carrier:</label>
            <select
              value={carrier}
              onChange={(e) => setCarrier(e.target.value)}
              style={{ width: '100%', padding: '5px' }}>
              {selectedCustomerId === 'CU-000972' ? ( //this is EIGHT Beer
                <>
                  <option value=""></option>
                  <option value="Ryan Transportation">Ryan Transportation</option>
                </>
                
              ) : ( //this is crazy mountain
                <>
                  <option value=""></option>
                  <option value="CH Robinson">CH Robinson</option>
                  <option value="R.C. Moore">R.C. Moore</option>
                  <option value="RXO">RXO</option>
                  <option value="Ryan Transportation">Ryan Transportation</option>
                  <option value="Tuckernuck Logistics">Tuckernuck Logistics</option>
                  <option value="Worldwide Express">Worldwide Express</option>
                  <option value="AMAZON">AMAZON</option>
                </>
              )}
            </select>
          </div>
        )}
        
        <div className="form-group" style={{ marginBottom: '15px' }}>
          <label style={{ textAlign: 'left', display: 'block' }}>Shipping info: <span style={{ color: 'orange' }}>*</span></label>
          <select
            onChange={handleSelectedShippingInfo}
            style={{ width: '100%', padding: '5px' }}
          >
            <option value=""></option>
            {ShipmentData ? (
              ShipmentData.map((item, index) => (
                <option key={index} value={item.shipToCode + '_' + item.shippingAgentCode + '_' + item.locationCode}>
                  {`SHIP TO: ${CONTRACT_CUSTOMER_IDS.includes(selectedCustomerId) ? '' : `(${item.shippingAgentCode}) `}${item.shipToAddress}, ${item.shipToAddress2 ? item.shipToAddress2 + ', ' : ''}${item.shipToCity}, ${item.shipToState} ${item.shipToPostcode} ${CONTRACT_CUSTOMER_IDS.includes(selectedCustomerId) ? '' : ` FROM ${item.locationCode} ${item.locationName}`}`}
                </option>
              ))
              ) : (
              <option>Loading shipment data...</option>
            )}
          </select>
        </div>
        
        <div className="form-group" style={{ marginBottom: '15px' }}>
          <label style={{ textAlign: 'left', display: 'block' }}>Requested Ship Date: <span style={{ color: 'orange' }}>*</span></label>
          <DatePicker
            selected={requestedShipDate}
            onChange={(date) => setRequestedShipDate(date)}
            dateFormat="MM/dd/yyyy"
            style={{ 
              width: '100% !important', 
              padding: '5px', 
              display: 'block !important',
              boxSizing: 'border-box',
              minWidth: '98%'
            }}
            wrapperClassName="date-picker-wrapper"
            className="date-picker-input"
            minDate={CONTRACT_CUSTOMER_IDS.includes(selectedCustomerId) ? new Date() : (OrderCycleInfo ? new Date(OrderCycleInfo.minShipDate) : new Date())}
            maxDate={CONTRACT_CUSTOMER_IDS.includes(selectedCustomerId) ? null : (OrderCycleInfo ? new Date(OrderCycleInfo.maxShipDate) : null)}
            filterDate={(date) => {
              const minDate = OrderCycleInfo ? new Date(OrderCycleInfo.minShipDate) : null;
              const maxDate = OrderCycleInfo ? new Date(OrderCycleInfo.maxShipDate) : null;
              const today = new Date();
              today.setHours(0, 0, 0, 0); // Reset time to beginning of day for comparison
              const day = date.getDay();
              
              // Different date rules for contract customers (CU-001034, CU-000972)
              if (CONTRACT_CUSTOMER_IDS.includes(selectedCustomerId)) {
                // No weekends (Sat/Sun), and enforce 5 business days from today as the earliest selectable date
                const specialMin = today;
                const notBeforeSpecialMin = date >= specialMin;
                const noWeekend = day !== 0 && day !== 6;
                return notBeforeSpecialMin && noWeekend;
              }
              
              // Default rules for other customers - weekdays only
              if (minDate && maxDate) {
                return date >= minDate && date <= maxDate && day !== 0 && day !== 6;
              }
              return day !== 0 && day !== 6; // Fallback to weekdays only if OrderCycleInfo not loaded
            }}
          />
        </div>
        
        {/*{selectedCustomerId === 'CU-001034' && (*/}
          <div className="form-group" style={{ marginBottom: '15px' }}>
            <label style={{ textAlign: 'left', display: 'block' }}>Pool Load:</label>
            <input
              type="text"
              value={poolLoad}
              onChange={(e) => setPoolLoad(e.target.value)}
              style={{ width: '98%', padding: '5px' }}
            />
          </div>
        {/*)}*/}
        
        <div className="form-group" style={{ marginBottom: '15px' }}>
          <label style={{ textAlign: 'left', display: 'block' }}>Freight arranged by: <span style={{ color: 'orange' }}>*</span></label>
          <select defaultValue="" onChange={handleFreightChange} style={{ width: '100%', padding: '5px' }}>
            <option value=""></option>
            <option value="true">Duvel USA</option>
            <option value="false">Distributor arranges freight</option>
          </select>
        </div>
        
        {/*<div style={{ marginBottom: '15px' }}>
          <strong>PLEASE NOTE</strong>
          <p>Please read <a href="#" style={{ color: 'white' }}>Duvel USA Terms of Sale</a> and <a href="#" style={{ color: 'white' }}>Duvel USA Shipping Guidelines</a></p>
        </div>*/}
        
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <button type="button" style={{ width: '48%', padding: '10px', backgroundColor: '#a51a2d', color: 'white', border: 'none' }} onClick={onClose}>CANCEL</button>
          {!startingNewOrder && (
            <button type="submit"style={{ width: '48%', padding: '10px', backgroundColor: '#a51a2d', color: 'white', border: 'none', cursor: 'pointer' }} onClick={handleCreateNewOrder}>OK</button>
          )}
        </div>
      </>
    </div>
  );
};

export default NewOrder;